<template>
  <div style="background-color: #fafafa;padding: 20px">

    <div v-if="!isOfmom" style="font-size: 20px">
      <el-breadcrumb separator="/" style="margin-left: 10px; margin-top: 5px">
        <el-breadcrumb-item :to="{ path: '/console' }">数据中心</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/PurchaseSaleStorage' }">进销存管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div style="font-size: 25px;margin-top: 15px;">
      <p>进销存管理</p>
    </div>
    <div v-if="isOfmom">
      <div style="font-family: 微软雅黑;font-weight: bold">
        <h3 style="padding: 10px 0">时间选择</h3>
        <div style="margin-bottom: 10px">
          <el-date-picker
            v-model="datetime"
            :picker-options="pickerOptions"
            align="right"
            end-placeholder="结束日期"
            range-separator="-"
            start-placeholder="开始日期"
            type="daterange"
            unlink-panels
            value-format="yyyy-MM-dd">
          </el-date-picker>
        </div>
        <!--        <input type="file" ref="uploadOfmomStockTemplate" v-show="false" accept=".xls,.xlsx" @change="uploadOfmomStockTemplate('OUT')"/>-->
      </div>

      <div style="font-family: 微软雅黑;font-weight: bold">
        <h3 style="padding: 10px 0">进货数据</h3>
        <div style="margin-bottom: 10px">
          <el-select v-if="suppliers && suppliers.length >= 1" v-model="stockSupplier"
                     :disabled="!config.id || !config.propId.disabled"
                     size="small" style="width: 120px;margin-right: 9px" value-key="id">
            <el-option v-for="s in suppliers" :key="s.id" :label="s.name" :value="s.id"/>
          </el-select>
          <el-button :loading="uploadStockTemplateLoading" class="ov-button" size="small"
                     @click="openOfmomUploadStockTemplate('IN')">上传进货数据
          </el-button>
          <el-button :loading="downloadStockLoading" class="ov-button" size="small"
                     @click="downloadOfmomData('IN')">导出进货数据
          </el-button>
        </div>
        <!--        <input type="file" ref="uploadOfmomStockTemplate" v-show="false" accept=".xls,.xlsx" @change="uploadOfmomStockTemplate('IN')"/>-->
      </div>
      <div style="font-family: 微软雅黑;font-weight: bold">
        <h3 style="padding: 10px 0">出货数据</h3>
        <div style="margin-bottom: 10px">
          <el-select v-if="suppliers && suppliers.length >= 1" v-model="stockSupplier"
                     :disabled="!config.id || !config.propId.disabled"
                     size="small" style="width: 120px;margin-right: 9px" value-key="id">
            <el-option v-for="s in suppliers" :key="s.id" :label="s.name" :value="s.id"/>
          </el-select>
          <el-button :loading="uploadStockTemplateLoading" class="ov-button" size="small"
                     @click="openOfmomUploadStockTemplate('OUT')">上传出货数据
          </el-button>
          <el-button :loading="downloadStockLoading" class="ov-button" size="small"
                     @click="downloadOfmomData('OUT')">导出出货数据
          </el-button>
        </div>
        <!--        <input type="file" ref="uploadOfmomStockTemplate" v-show="false" accept=".xls,.xlsx" @change="uploadOfmomStockTemplate('OUT')"/>-->
      </div>

      <div style="font-family: 微软雅黑;font-weight: bold">
        <h3 style="padding: 10px 0">库存数据</h3>
        <div style="margin-bottom: 10px">
          <el-select v-if="suppliers && suppliers.length >= 1" v-model="stockSupplier"
                     :disabled="!config.id || !config.propId.disabled"
                     size="small" style="width: 120px;margin-right: 9px" value-key="id">
            <el-option v-for="s in suppliers" :key="s.id" :label="s.name" :value="s.id"/>
          </el-select>
          <el-button :loading="uploadStockTemplateLoading" class="ov-button" size="small"
                     @click="openOfmomUploadStockTemplate('STOCK')">上传库存数据
          </el-button>
          <el-button :loading="downloadStockLoading" class="ov-button" size="small"
                     @click="downloadOfmomData('STOCK')">导出库存数据
          </el-button>
        </div>
        <input v-show="false" ref="uploadOfmomStockTemplate" accept=".xls,.xlsx" type="file"
               @change="uploadOfmomStockTemplate()"/>
      </div>

      <el-link @click="openUploadRecordDialog">查看数据上传记录</el-link>

      <el-dialog
        :before-close="handleCloseRecord"
        :close-on-click-modal="false"
        :show-close="false"
        :visible.sync="uploadRecordDialog"
        center
        width="60%">
        <div slot="title" class="dialog-title">
          <el-row :gutter="20" align="middle" type="flex">
            <el-col :offset="8" :span="8">
              <div class="grid-content bg-purple">经销商数据上传记录</div>
            </el-col>
            <el-col :offset="3" :span="5">
              <div class="grid-content bg-purple">
                <el-select v-model="uploadRecordType" clearable
                           placeholder="请选择"
                           size="mini" style="display: inline-block; float: right"
                           @change="showUploadRecord(1)" @clear="clearRecord">
                  <el-option
                    v-for="item in uploadRecordTypeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </el-col>
          </el-row>
        </div>

        <span style="text-align: center">
          <el-table
            v-loading="recordTableLoading"
            :data="recordTable.list"
            border
            max-height="400"
            style="width: 100%">
            <el-table-column
              align="center" label="文件名" min-width="50%"
            >
               <template slot-scope="scope">
                   <el-link :href="scope.row.link" :underline="false" target="_blank">{{ scope.row.fileName }}</el-link>
              </template>
            </el-table-column>
            <el-table-column
              align="center" label="上传时间"
              prop="createdTime"
              min-width="15%">
            </el-table-column>
            <el-table-column
              align="center" label="上传账号"
              prop="userId"
              min-width="15%">
            </el-table-column>
             <el-table-column
               align="center" label="涉及经销商"
               prop="supplierName"
               min-width="15%">
            </el-table-column>
          </el-table>

          <el-pagination
            :hide-on-single-page="recordTable"
            :page-size="15"
            :total="recordTable.total"
            layout="prev, pager, next"
            @current-change="showUploadRecord">
          </el-pagination>
        </span>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="uploadRecordDialog = false">返回</el-button>
        </span>
      </el-dialog>

      <el-dialog
        :before-close="handleClose"
        :close-on-click-modal="false"
        :visible.sync="uploadDialog"
        center
        width="30%">
        <div slot="title" class="dialog-title">
          <span v-if="ofmomUploadType === 'IN'">经销商进货数据上传</span>
          <span v-if="ofmomUploadType === 'OUT'">经销商出货数据上传</span>
          <span v-if="ofmomUploadType === 'STOCK'">经销商期初库存上传</span>
        </div>

        <div class="dialog-body">
          <div>
            <span v-if="ofmomUploadType === 'IN'">1、请先下载进货数据模版：</span>
            <span v-if="ofmomUploadType === 'OUT'">1、请先下载出货数据模版：</span>
            <span v-if="ofmomUploadType === 'STOCK'">1、请先下载期初库存模版：</span>
            <el-link @click="downloadOfmomTemplate(ofmomUploadType)">下载模版</el-link>
          </div>

          <div class="dialog-description">
            <div>使用说明：</div>
            <div>1、请先下载模板后，在模板基础上填写，勿新增或删除字段。</div>
          </div>

          <div>
            <div>2、点击上传填写完成的进货数据</div>
          </div>
          <el-upload
            ref="upload"
            :auto-upload="false"
            :file-list="uploadSuccessExcelList"
            :http-request="uploadMethod"
            accept=".xls,.xlsx"
            action="#"
            class="avatar-uploader"
            multiple>
            <i class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button :loading="uploadStockTemplateLoading" style="margin-bottom: 10px" type="primary"
                     @click="submitUpload">确定上传</el-button>
        </span>
      </el-dialog>
    </div>

    <div v-if="!isOfmom" v-loading="initLoading">
      <div style="font-family: 微软雅黑;font-weight: bold;">
        <h3>全局配置</h3>
        <el-form ref="configForm" :inline="true" :model="config" :rules="rules" label-position="top" size="small">
          <el-form-item label="品牌设置">
            <el-tooltip class="item" content="切换品牌配置与数据" effect="dark" placement="bottom">
              <el-select v-model="parentBrandId" style="width: 150px" @change="parentBrandsChange">
                <el-option v-for="p in parentBrands" :key="p.id" :label="p.parentBrand" :value="p.id"></el-option>
              </el-select>
            </el-tooltip>
          </el-form-item>
          <el-form-item label="门店进货起计时间" prop="stockStartTime.value">
            <config-edit v-model="config.stockStartTime.disabled"
                         :button="config.brandAdmin"
                         :width="180"
                         size="small" @configEdit="editConfig('stock_start_time',config.stockStartTime)">
              <template slot="el">
                <el-tooltip class="item" content="修改起计时间后，相关数据将会重新计算，如无必要请勿修改" effect="dark"
                            placement="bottom">
                  <el-date-picker
                    v-model="config.stockStartTime.value"
                    :clearable="false"
                    :disabled="config.stockStartTime.disabled"
                    :editable="false"
                    format="yyyy-MM-dd"
                    placeholder="选择日期"
                    style="width: unset"
                    type="date"
                    value-format="yyyy-MM-dd">
                  </el-date-picker>
                </el-tooltip>
              </template>
            </config-edit>
          </el-form-item>
          <el-form-item label="门店销售起计时间" prop="saleStartTime.value">
            <config-edit v-model="config.saleStartTime.disabled"
                         :button="config.brandAdmin"
                         :width="180"
                         size="small" @configEdit="editConfig('sale_start_time',config.saleStartTime)">
              <template slot="el">
                <el-tooltip class="item" content="修改起计时间后，相关数据将会重新计算，如无必要请勿修改" effect="dark"
                            placement="bottom">
                  <el-date-picker
                    v-model="config.saleStartTime.value"
                    :clearable="false"
                    :disabled="config.saleStartTime.disabled"
                    :editable="false"
                    format="yyyy-MM-dd"
                    placeholder="选择日期"
                    style="width: unset"
                    type="date"
                    value-format="yyyy-MM-dd">
                  </el-date-picker>
                </el-tooltip>
              </template>
            </config-edit>
          </el-form-item>
          <el-form-item label="风控转审开关">
            <el-tooltip class="item" effect="dark" placement="bottom">
              <template slot="content">
                <div style="text-align: center">
                  打开此开关后，处于预警状态的门店下的风险订单将移交<br/>
                  给厂商指定的业务员进行审批
                </div>
              </template>
              <config-edit
                v-model="config.inventoryMonitor.disabled"
                :button="config.brandAdmin" size="small"
                @configEdit="editConfig('inventory_monitor',config.inventoryMonitor)">
                <template slot="el">
                  <el-button v-model="config.inventoryMonitor.value"
                             :disabled="config.inventoryMonitor.disabled"
                             :style="{'width': config.brandAdmin ? '80px':'104px'}" class="ov-button"
                             @click="config.inventoryMonitor.value = 1 - config.inventoryMonitor.value">
                    {{ config.inventoryMonitor.value == 0 ? '未启用' : '转审中' }}
                  </el-button>
                </template>
              </config-edit>
            </el-tooltip>
          </el-form-item>
          <br>
          <el-form-item label="汇总维度设置" prop="propId.value">
            <config-edit v-model="config.propId.disabled"
                         :button="config.brandAdmin"
                         :width="180"
                         size="small" @configEdit="editConfig('prop_id',config.propId)">
              <template slot="el">
                <el-tooltip class="item" effect="dark" placement="bottom">
                  <template slot="content">
                    你可以设定产品的地区汇总维度<br/>
                    也可以通过<a href="javascript:void(0);" @click="toLabelView">自定义标签</a>自行控制
                  </template>
                  <el-select
                    v-model="config.propId.value"
                    :disabled="config.propId.disabled">
                    <el-option v-for="p in propOptions" :key="p.id" :label="p.name" :value="p.id"></el-option>
                  </el-select>
                </el-tooltip>
              </template>
            </config-edit>
          </el-form-item>
          <el-form-item label="全局库存容差" prop="tolerance.value">
            <config-edit v-model="config.tolerance.disabled"
                         :button="config.brandAdmin"
                         size="small" @configEdit="editConfig('tolerance',config.tolerance)">
              <template slot="el">
                <el-tooltip class="item" content="将您的产品编码，与我们的系统商品匹配起来" effect="dark"
                            placement="bottom">
                  <template slot="content">
                    <div style="text-align: center">
                      若 进货数总计 + 库存容差 &lt; 已售出数总计 + 当前待审批，<br/>
                      则门店将进入预警状态。<br/>
                      您可以对品牌简单做一个全局库存容差，也可以根据您的维度设置进行精细控制，<br/>
                      如果未配置，系统将以全局库存容差为准
                    </div>
                  </template>
                  <el-input-number v-model="config.tolerance.value" :disabled="config.tolerance.disabled"
                                   :max="999999999" :min="-999999999"
                                   :precision="0"
                                   :step="10"
                                   controls-position="right">
                  </el-input-number>
                </el-tooltip>
              </template>
            </config-edit>
          </el-form-item>
          <el-form-item v-if="config.brandAdmin" label="容差分级配置">
            <div>
              <el-button :disabled="!config.propId.disabled" :loading="downloadPropTemplateLoading" class="ov-button"
                         @click="downloadPropTemplate">下载配置模板
              </el-button>
              <el-button :disabled="!config.propId.disabled" :loading="uploadPropTemplateLoading" class="ov-button"
                         @click="openUploadPropTemplate">上传更新数据
              </el-button>
            </div>
          </el-form-item>
          <input v-show="false" ref="uploadToleranceTemplate" accept=".xls,.xlsx" type="file"
                 @change="uploadToleranceTemplate"/>
          <el-form-item label="商品数据匹配">
            <el-tooltip class="item" content="将您的产品编码，与我们的系统商品匹配起来" effect="dark" placement="bottom">
              <div>
                <el-button :disabled="parentBrands.length == 0 || !config.id" :loading="downloadDataTemplateLoading"
                           class="ov-button" @click="downloadDataTemplate">下载当前配置
                </el-button>
                <el-button :disabled="parentBrands.length == 0 || !config.brandAdmin || dashboardSales"
                           :loading="uploadDataTemplateLoading"
                           class="ov-button"
                           @click="uploadDataTemplateOpen">上传匹配数据
                </el-button>
              </div>
            </el-tooltip>
          </el-form-item>
          <el-form-item label="汇总维度切换" v-if="propUpdateDialog.isProp">
            <el-button :loading="propUpdateLoading"
                       class="ov-button"
                       @click="openPropUpdateDialog">汇总维度切换
            </el-button>
          </el-form-item>
          <input v-show="false" ref="uploadDataTemplate" accept=".xls,.xlsx" type="file" @change="uploadDataTemplate"/>
        </el-form>
      </div>

      <div v-if="config.brandAdmin || purchaseUpload == 1" class="divider"/>

      <div v-if="config.brandAdmin || purchaseUpload == 1" style="font-family: 微软雅黑;font-weight: bold">
        <h3 style="padding: 10px 0">进货数据上传</h3>
        <div style="margin-bottom: 10px">
          <el-select v-if="suppliers && suppliers.length >= 1" v-model="stockSupplier"
                     :disabled="!config.id || !config.propId.disabled"
                     size="small" style="width: 120px;margin-right: 9px" value-key="id">
            <el-option v-for="s in suppliers" :key="s.id" :label="s.name" :value="s.id"/>
          </el-select>
          <el-button :disabled="!config.id || !config.propId.disabled" :loading="downloadStockTemplateLoading"
                     class="ov-button" size="small" @click="downloadStockTemplate">下载填写模板
          </el-button>
          <el-button :disabled="!config.id || !config.propId.disabled || dashboardSales"
                     :loading="uploadStockTemplateLoading"
                     class="ov-button" size="small" @click="openUploadStockTemplate">上传进货数据
          </el-button>
        </div>
        <input v-show="false" ref="uploadStockTemplate" accept=".xls,.xlsx" type="file" @change="uploadStockTemplate"/>
      </div>

      <div class="divider"/>

      <div style="font-family: 微软雅黑;font-weight: bold">
        <div class="ov-inline" style="width: 49%">
          <h3 style="padding: 10px 0">进销存管理报告</h3>
          <el-form ref="saleReportForm" :disabled="formDisabled" :model="saleReportForm" :rules="rules"
                   label-width="90px">
            <el-form-item label="销售时间" prop="range">
              <el-date-picker
                v-model="saleReportForm.range"
                :clearable="false"
                :editable="false"
                :picker-options="saleRangeOptions"
                end-placeholder="结束日期"
                format="yyyy-MM-dd"
                range-separator="-"
                start-placeholder="开始日期"
                type="daterange"
                unlink-panels
                value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="品类" prop="brands">
              <el-select v-model="saleReportForm.brands" multiple placeholder="可筛选，不筛选则导出全部"
                         popper-class="el-select" style="width: 350px" value-key="id">
                <select-all-option v-model="saleReportForm.brands" :data="categorys"/>
                <el-option v-for="r in categorys" :key="r.id" :label="r.name" :value="r"/>
              </el-select>
            </el-form-item>
            <el-form-item label="商品" prop="products">
              <el-select v-model="saleReportForm.products" :disabled="saleReportForm.brands.length == 0" multiple
                         placeholder="可筛选，不筛选则导出全部" popper-class="el-select" style="width: 350px"
                         value-key="id">
                <ov-option :parent="saleReportForm.brands" :prison.sync="saleReportForm.products"
                           :value="saleReportForm.brands" children="children"
                           group-key="id" group-label="name" group-value="children"
                           label="name" option-key="id" parent-children="children"/>
              </el-select>
            </el-form-item>
            <el-form-item label="区域" prop="regionals">
              <el-select v-model="saleReportForm.regionals" multiple placeholder="可筛选，不筛选则导出全部"
                         popper-class="el-select" style="width: 350px" value-key="id">
                <ov-option :parent="saleReportForm.brands" :prison.sync="saleReportForm.regionals" :value="saleRegions"
                           label="name"
                           option-key="id"/>
              </el-select>
            </el-form-item>
            <el-form-item label="省份" prop="provinces">
              <el-select v-model="saleReportForm.provinces" :disabled="saleReportForm.regionals.length == 0" multiple
                         placeholder="可筛选，不筛选则导出全部" popper-class="el-select" style="width: 350px"
                         value-key="id">
                <ov-option :parent="saleReportForm.regionals" :prison.sync="saleReportForm.provinces"
                           :value="saleReportForm.regionals" children="children"
                           group-key="id" group-label="name"
                           label="name" option-key="id" parent-children="children"/>
              </el-select>
            </el-form-item>
            <el-form-item v-if="this.config.propId.value != 'province'" label="城市" prop="citys">
              <el-select v-model="saleReportForm.citys" :disabled="saleReportForm.provinces.length == 0" multiple
                         placeholder="可筛选，不筛选则导出全部" popper-class="el-select" style="width: 350px"
                         value-key="id">
                <ov-option :parent="saleReportForm.provinces" :prison.sync="saleReportForm.citys"
                           :value="saleReportForm.provinces" children="children"
                           group-key="id" group-label="name"
                           label="name" option-key="id" parent-children="children"/>
              </el-select>
            </el-form-item>
            <el-form-item label="自定义标签" prop="extras">
              <el-select v-model="saleReportForm.propValues" multiple placeholder="可筛选，不筛选则导出全部数据"
                         popper-class="el-select" style="width: 350px" clearable filterable :filter-method="queryPropValues" @focus="() =>queryPropValues('')">
                <el-option v-for="r in propValues" :key="r" :label="r" :value="r"/>
              </el-select>
              <el-tooltip class="item" effect="dark" placement="right" content="仅支持自定义标签筛选后查看">
                <el-button :disabled="saleReportForm.propValues.length === 0"
                           style="margin-left: 10px"
                           :loading="downloadSaleReportLoading" size="small"
                           class="ov-button" @click="querySaleReport">在线查看
                </el-button>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="预警状态" prop="inventoryMonitor">
              <el-tooltip class="item" effect="dark" placement="bottom">
                <template slot="content">
                  预警中：门店已上传过相关进货数据，该门店当前有超售风险<br/>
                  （当前进货数总计 + 库存容差 < 已售出数总计 + 当前待审批）。<br/>
                  （此时如风控转审开关为开启状态，则该门店后续的申报都将交由业务员人工审核，直到其再次进货解除风险状态为止）<br/><br/>
                  未预警：门店已上传过相关进货数据，该门店当前无超售风险（当前进货数总计 + 库存容差 > 已售出数总计 +
                  当前待审批）。<br/><br/>
                  未监控：门店未上传过进货数据，不对其采取相关风控措施。
                </template>
                <el-select v-model="saleReportForm.inventoryMonitor" multiple placeholder="可筛选，不筛选则导出全部"
                           popper-class="el-select" style="width: 350px">
                  <select-all-option v-model="saleReportForm.inventoryMonitor" :data="inventoryMonitors"/>
                  <el-option v-for="item in inventoryMonitors" :key="item" :label="item" :value="item"/>
                </el-select>
              </el-tooltip>
            </el-form-item>
            <el-form-item>
              <el-tooltip class="item" effect="dark" placement="bottom">
                <template slot="content">
                  <div style="text-align: center">
                    若维度下无进货数据，则不会进行数据匹配，也不会进入库存报告，<br>
                    如有需要可上传0进货数据（不推荐，数据更新时会立即预警）。
                  </div>
                </template>
                <el-button :disabled="categorys.length == 0 || saleReportForm.range.length != 2"
                           :loading="downloadSaleReportLoading"
                           class="ov-button" @click="downloadSaleReport">导出EXCEL
                </el-button>
              </el-tooltip>
            </el-form-item>
          </el-form>
        </div>
        <div v-if="config.brandAdmin || purchaseDataImport == 1" class="ov-inline" style="width: 49%">
          <h3 style="padding: 10px 0">进货数据导出</h3>
          <el-form ref="purchaseReportForm" :disabled="formDisabled" :model="purchaseReportForm" :rules="rules"
                   label-width="90px">
            <el-form-item label="进货时间" prop="range">
              <el-date-picker
                v-model="purchaseReportForm.range"
                :clearable="false"
                :editable="false"
                end-placeholder="结束日期"
                format="yyyy-MM-dd"
                range-separator="-"
                start-placeholder="开始日期"
                type="daterange"
                unlink-panels
                value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="品类" prop="brands">
              <el-select v-model="purchaseReportForm.brands" multiple placeholder="可筛选，不筛选则导出全部"
                         popper-class="el-select" style="width: 350px" value-key="id">
                <select-all-option v-model="purchaseReportForm.brands" :data="categorys"/>
                <el-option v-for="r in categorys" :key="r.id" :label="r.name" :value="r"/>
              </el-select>
            </el-form-item>
            <el-form-item label="商品" prop="products">
              <el-select v-model="purchaseReportForm.products" :disabled="purchaseReportForm.brands.length == 0"
                         multiple
                         placeholder="可筛选，不筛选则导出全部" popper-class="el-select" style="width: 350px"
                         value-key="id">
                <ov-option :parent="purchaseReportForm.brands" :prison.sync="purchaseReportForm.products"
                           :value="purchaseReportForm.brands" children="children"
                           group-key="id" group-label="name"
                           label="name" option-key="id" parent-children="children"/>
              </el-select>
            </el-form-item>
            <el-form-item label="供应商" prop="suppliers">
              <el-select v-model="purchaseReportForm.suppliers" multiple placeholder="可筛选，不筛选则导出全部"
                         popper-class="el-select" style="width: 350px" value-key="id">
                <ov-option :parent="purchaseReportForm.brands" :prison.sync="purchaseReportForm.suppliers"
                           :value="stockSuppliers" label="name"
                           option-key="id"/>
              </el-select>
            </el-form-item>
            <el-form-item v-if="isProvinces" label="区域" prop="regionals">
              <el-select v-model="purchaseReportForm.regionals" multiple placeholder="可筛选，不筛选则导出全部"
                         popper-class="el-select" style="width: 350px" value-key="id">
                <ov-option :parent="purchaseReportForm.brands" :prison.sync="purchaseReportForm.regionals"
                           :value="stockRegions" label="name"
                           option-key="id"/>
              </el-select>
            </el-form-item>
            <el-form-item v-if="isProvinces" label="省份" prop="provinces">
              <el-select v-model="purchaseReportForm.provinces" :disabled="purchaseReportForm.regionals.length == 0"
                         multiple
                         placeholder="可筛选，不筛选则导出全部" popper-class="el-select" style="width: 350px"
                         value-key="id">
                <ov-option :parent="purchaseReportForm.regionals" :prison.sync="purchaseReportForm.provinces"
                           :value="purchaseReportForm.regionals" children="children"
                           group-key="id" group-label="name"
                           label="name" option-key="id" parent-children="children"/>
              </el-select>
            </el-form-item>
            <el-form-item v-if="isCity" label="城市" prop="citys">
              <el-select v-model="purchaseReportForm.citys" :disabled="purchaseReportForm.provinces.length == 0"
                         multiple
                         placeholder="可筛选，不筛选则导出全部" popper-class="el-select" style="width: 350px"
                         value-key="id">
                <ov-option :parent="purchaseReportForm.provinces" :prison.sync="purchaseReportForm.citys"
                           :value="purchaseReportForm.provinces" children="children"
                           group-key="id" group-label="name"
                           label="name" option-key="id" parent-children="children"/>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button :disabled="categorys.length == 0 || purchaseReportForm.range.length != 2"
                         :loading="downloadStockLoading"
                         class="ov-button" @click="downStock">导出EXCEL
              </el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="propUpdateDialog.visible"
      width="500px"
      class="uploadDialog"
      :close-on-click-modal="false"
      center>
      <div slot="title" class="dialog-title">进销存汇总维度切换</div>
      <div class="content">
        <div class="title" style="text-align: center;font-size: 17px">1、请先下载进销存汇总维度切换模版
          <el-button type="text" @click="downloadUpdatePropTemplate" :disabled="propUpdateDialog.downDisabled" style="font-size: 17px">下载模板</el-button>
        </div>
        <div class="description" style="margin-top: 10px">
          使用说明：<br/>
          1、	请先下载进销存汇总维度切换模版，在模板基础上填写，勿新增或删除字段。<br/>
          2、	请在左边列填写系统中现有的进销存汇总维度名称，对应的右边列填写切换后的进销存汇总维度名称<br/>
          3、上传后会同步调整对应的历史进销存数据。
        </div>
        <div class="title" style="text-align: center;font-size: 17px;margin-top: 20px">2、点击上传填写完成的进销存汇总维度切换模版</div>
        <div style="margin-top: 20px;text-align: center;">
          <el-upload
            :disabled="propUpdateDialog.loading"
            class="upload"
            ref="uploadBatch"
            action="#"
            accept=".xls,.xlsx"
            :show-file-list="false"
            :http-request="(file) => propUpdateDialog.file = file.file">
            <div slot="trigger" class="description">
              <i class="el-icon-plus" style="padding: 10px 20px; color: #00000066; font-size: 20px"></i>
            </div>
          </el-upload>
          <div style="margin-top: 10px" v-if="propUpdateDialog.file">{{propUpdateDialog.file.name}}</div>
        </div>
        <div style="text-align: center; margin-top: 50px;">
          <el-button :loading="propUpdateDialog.loading" type="primary" :disabled="propUpdateDialog.file === null" @click="uploadPropUpdateSubmit">确定上传</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="saleReportDialog.visible"
      width="1500px"
      class="details"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      center>
      <div v-loading="saleReportDialog.loading">
        <div slot="title" class="dialog-title" style="text-align: center;margin-bottom: 20px">进销存报告</div>
        <div style="text-align: center">
          <el-table
            :data="saleReportDialog.tableData"
            border
            :height="windowHeight/1.4"
            style="width: 100%">
            <el-table-column
              width="50"
              label="序号" align="center">
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column
              label="维度"
              prop="propName"
              align="center"
              width="100">
            </el-table-column>
            <el-table-column
              label="品牌"
              align="center"
              prop="parentBrand">
            </el-table-column>
            <el-table-column
              label="品类"
              align="center"
              prop="category">
            </el-table-column>
            <el-table-column
              label="商品汇总名"
              align="center"
              width="200"
              prop="parentBarcodeName">
            </el-table-column>
            <el-table-column
              label="商品汇总编码"
              width="150"
              align="center"
              prop="parentBarcodeId">
            </el-table-column>
            <el-table-column
              label="起止时间"
              align="center"
              width="150"
              prop="startAndEnd">
            </el-table-column>
            <el-table-column
              label="期初库存"
              align="center"
              prop="openingInventory">
            </el-table-column>
            <el-table-column
              label="进货量"
              align="center"
              prop="purchaseQuantity">
            </el-table-column>
            <el-table-column
              label="进货次数"
              align="center"
              prop="purchaseCount">
            </el-table-column>
            <el-table-column
              label="售出数"
              align="center"
              prop="salesVolume">
            </el-table-column>
            <el-table-column
              label="日均售出"
              align="center"
              prop="salesVolumeDay">
            </el-table-column>
            <el-table-column
              label="期末库存"
              align="center"
              prop="endingInventory">
            </el-table-column>
            <el-table-column
              label="周转天数"
              align="center"
              prop="turnoverCycle">
            </el-table-column>
            <el-table-column
              label="当前待审批"
              align="center"
              width="150"
              prop="approvalCount">
            </el-table-column>
            <el-table-column
              label="当前库存"
              align="center"
              prop="currentInventory">
            </el-table-column>
            <el-table-column
              label="库存容差"
              align="center"
              prop="tolerance">
            </el-table-column>
            <el-table-column
              label="预警状态"
              align="center"
              prop="inventoryMonitor">
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import configEdit from '@/components/configEdit'
import ovOption from '@/components/ovOption'
import selectAllOption from '@/components/selectAllOption'
import {
  brandConfigEdit,
  downloadDataTemplate,
  downloadOfmomData,
  downloadOfmomTemplate,
  downloadPropTemplate,
  downloadSaleReport,
  downloadStockTemplate, downloadSupplierPropValue,
  downStock,
  init, queryPropValues, querySaleReport,
  queryUploadRecord,
  selectBrandConfig,
  uploadDataTemplate,
  uploadOfmomStockTemplate,
  uploadPropTemplate,
  uploadStockTemplate, uploadSupplierPropValue
} from "@/api/SaleStorage"
import {parseTime} from '@/utils/index'
import * as XLSX from 'xlsx';

export default {
  name: "PurchaseSaleStorage",
  components: {configEdit, ovOption, selectAllOption},
  data() {
    return {
      token: '',
      dashboardSales: false,
      // 品牌设置下拉框option
      parentBrands: [],
      // 选择的品牌ID
      parentBrandId: undefined,
      // 维度设置下拉框option
      propOptions: [],
      // 是否显示进货数据上传
      purchaseUpload: undefined,
      // 是否显示进货数据导出
      purchaseDataImport: undefined,
      // 初始化页面遮罩层
      initLoading: true,
      // 数据匹配模板下载遮罩层
      downloadDataTemplateLoading: false,
      // 数据匹配上传遮罩层
      uploadDataTemplateLoading: false,
      // 分级容差模板下载遮罩层
      downloadPropTemplateLoading: false,
      // 分级容差模板上传遮罩层
      uploadPropTemplateLoading: false,
      // 进货数据模板下载遮罩层
      downloadStockTemplateLoading: false,
      // 进货数据模板上传遮罩层
      uploadStockTemplateLoading: false,
      // 进货数据下载遮罩层
      downloadStockLoading: false,
      // 进销存下载遮罩层
      downloadSaleReportLoading: false,
      // 进销存地区
      saleRegions: [],
      // 进货地区
      stockRegions: [],
      // 账户配置supplier
      suppliers: [],
      // 进货数据上传所选的supplier
      stockSupplier: undefined,
      isOfmom: false,
      ofmomUploadType: '',
      // 全局配置
      config: {
        //门店进货起计时间
        stockStartTime: {value: undefined, disabled: true},
        //销售起计时间
        saleStartTime: {value: undefined, disabled: true},
        //库存容差
        tolerance: {value: 0, disabled: true},
        //监控
        inventoryMonitor: {value: 0, disabled: true},
        //维度
        propId: {value: undefined, disabled: true},
        // 配置ID
        id: undefined,
        // 是否是品牌管理员
        brandAdmin: false
      },
      // 预警状态下拉框
      inventoryMonitors: ["未预警", "预警中", "未监控"],
      // 进销存管理表单
      saleReportForm: {
        range: [],
        brands: [],
        products: [],
        regionals: [],
        suppliers: [],
        provinces: [],
        citys: [],
        extras: [],
        inventoryMonitor: [],
        propValues: []
      },
      // 进货数据表单
      purchaseReportForm: {
        range: [],
        brands: [],
        products: [],
        regionals: [],
        suppliers: [],
        provinces: [],
        citys: [],
        propValues: []
      },
      propValues: [],
      categorys: [],
      extras: [],
      stockSuppliers: [],
      rules: {
        'stockStartTime.value': [
          {required: true, message: "门店进货起计时间不能为空", trigger: "blur"}
        ],
        'saleStartTime.value': [
          {required: true, message: "销售起计时间不能为空", trigger: "blur"}
        ],
        'tolerance.value': [
          {required: true, message: "库存容差不能为空", trigger: "blur"}
        ],
        'propId.value': [
          {required: true, message: "维度不能为空", trigger: "blur"}
        ],
        range: [
          {required: true, message: "起止时间内不能为空", trigger: "blur"}
        ]
      },
      datetime: [this.getStartTime(), this.getNowTime()],
      pickerOptions: {
        disabledDate: (time) => {
          return time.getTime() > Date.now();
        },
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },

      //ofomom上传文件dialog开关
      uploadDialog: false,
      //上传成功文件列表
      uploadSuccessExcelList: [],
      //经销商列表
      supplierListDialog: false,
      //经销商数据上传记录
      uploadRecordDialog: false,
      uploadRecordTypeList: [
        {label: '进货', value: 'IN'},
        {label: '出货', value: 'OUT'},
        {label: '期初库存', value: 'STOCK'}
      ],
      uploadRecordType: 'IN',
      //经销商数据上传记录表格数据
      recordTable: {},
      //经销商数据上传记录表格加载loading
      recordTableLoading: false,
      // 自定义标签修改加载
      propUpdateLoading: false,
      // 自定义标签修改dialog开关
      propUpdateDialog: {
        loading: false,
        visible: false,
        file: null,
        isProp: false,
        downDisabled: false
      },
      saleReportDialog: {
        visible: false,
        loading: false,
        tableData: []
      },
      windowHeight: window.innerHeight
    }
  },
  created() {
    this.dashboardSales = localStorage.getItem('dashboardSales') == 2 ? true : false
  },
  computed: {
    formDisabled() {
      let config = this.config
      return !config.id || !config.stockStartTime.disabled ||
        !config.saleStartTime.disabled || !config.propId.disabled ||
        !config.tolerance.disabled
    },
    purchaseRangeOptions() {
      let _this = this
      return {
        disabledDate(time) {
          let max = new Date(_this.config.stockStartTime.value)
          return time.getTime() < max.getTime()
        }
      }
    },
    saleRangeOptions() {
      let _this = this
      return {
        disabledDate(time) {
          // let max = new Date(_this.config.stockStartTime.value)
          let now = Date.now()
          // if (max >= now)
          //   return true
          // return time.getTime() < max.getTime() || time.getTime() > now
          return time.getTime() > now
        }
      }
    },
    isProvinces() {
      let value = this.config.propId.value
      return value == 'province' || this.isCity
    },
    isCity() {
      let value = this.config.propId.value
      return (value == 'city' || value == 'ovCode')
    }
  },
  mounted() {
    this.token = localStorage.getItem('token')
    this.init()
  },
  methods: {
    toLabelView() {
      this.$router.replace({name: 'LabelView'})
    },
    // 页面初始化数据
    init() {
      let {username} = JSON.parse(sessionStorage.getItem('user'))
      this.isOfmom = Boolean(username.indexOf('ofmom') > -1)
      init(this.token).then(({data}) => {
        let {date} = data
        let {parentBrand, extras, brandPurchaseUpload, purchaseDataImport, suppliers} = date
        this.purchaseUpload = brandPurchaseUpload
        this.parentBrands = parentBrand
        //默认选中第一个
        if (parentBrand && parentBrand.length > 0) {
          this.parentBrandId = parentBrand[0].id
          this.parentBrandsChange()
        }
        this.purchaseDataImport = purchaseDataImport
        this.propOptions = [
          {name: '省份', id: 'province'},
          {name: '城市', id: 'city'},
          {name: '橙子店码', id: 'ovCode'}
        ]
        this.suppliers = suppliers
        if (this.suppliers.length == 1)
          this.stockSupplier = this.suppliers[0].id
        this.propOptions = this.propOptions.concat(extras)
      }).catch(() => this.error("页面初始化失败，请联系管理员")).finally(() => this.initLoading = false)
    },
    //配置修改
    editConfig(name, val) {
      this.$refs['configForm'].validate(valid => {
        if (valid) {
          if (name == 'prop_id' || name == 'stock_start_time' || name == 'sale_start_time') {
            let message = "修改后数据统计区间范围将会改变，是否继续？"
            if (name == 'prop_id')
              message = "汇总维度设置修改后，之前维度的进货数据将不再生效，是否继续？"
            this.$confirm(message, '提示', {
              confirmButtonText: '是',
              cancelButtonText: '否',
              type: 'warning'
            }).then(() => {
              this.edit(name, val)
            }).catch(() => this.parentBrandsChange())
          } else {
            this.edit(name, val)
          }
        }
      })
    },
    edit(name, val) {
      let config = {name: name, value: val.value, id: this.config.id}
      this.initLoading = true
      brandConfigEdit(this.token, config).then(({data}) => {
        let {code, date, msg} = data
        if (code == 200) {
          if (name == 'prop_id' || name == 'stock_start_time') {
            this.parentBrandsChange()
          } else {
            this.assignmentConfig(date)
            this.initLoading = false
          }
          this.success(msg)
        } else if (code == 401) {
          this.initLoading = false
          this.error(msg)
          if (name == 'prop_id')
            this.emptyForm()
          this.assignmentConfig(date)
        } else if (code == 1) {
          this.initLoading = false
          this.error(msg)
        }
      }).catch(() => {
        this.emptyConfig()
        this.parentBrandId = undefined
        this.error("配置修改失败，请联系管理员")
        this.initLoading = false
      })
    },
    //品牌切换
    parentBrandsChange() {
      this.initLoading = true
      selectBrandConfig(this.token, this.parentBrandId).then(({data}) => {
        let {code, date, msg} = data
        this.emptyForm()
        if (code == 200) {
          let {brandConfig, form, saleRegions, stockRegions, extras, propValues} = date
          let {category, supplier} = form
          this.categorys = category
          this.saleRegions = saleRegions
          this.stockRegions = stockRegions
          this.extras = extras
          this.propValues = propValues
          if (!brandConfig.brandAdmin)
            this.stockSuppliers = this.suppliers
          else
            this.stockSuppliers = supplier
          this.assignmentConfig(brandConfig)
        } else if (code == 1) {
          this.error(msg)
          this.emptyConfig()
        }
      }).catch(() => {
        this.emptyConfig()
        this.parentBrandId = undefined
        this.error("查询失败，请联系管理员")
      }).finally(() => this.initLoading = false)
    },
    //查询当前维度得自定义标签数据
    queryPropValues(value) {
      value = value ? value : ''
      queryPropValues(this.token,this.config.propId.value,value).then(({data}) => {
        this.propValues = data.date
      })
    },
    // 全局配置赋值
    assignmentConfig(config) {
      this.config = {
        stockStartTime: {value: config.stockStartTime, disabled: true},
        saleStartTime: {value: config.saleStartTime, disabled: true},
        tolerance: {value: config.tolerance, disabled: true},
        inventoryMonitor: {value: config.inventoryMonitor, disabled: true},
        propId: {value: config.propId, disabled: true},
        id: config.id,
        brandAdmin: config.brandAdmin
      }
      this.propUpdateDialog.isProp = !['province','city','ovCode'].includes(this.config.propId.value)
      this.stockStartTimeFormatter(config)
    },
    // 清空配置还原初始状态
    emptyConfig() {
      this.config = {
        stockStartTime: {value: undefined, disabled: true},
        saleStartTime: {value: undefined, disabled: true},
        tolerance: {value: 0, disabled: true},
        inventoryMonitor: {value: 0, disabled: true},
        propId: {value: undefined, disabled: true},
        id: undefined,
        brandAdmin: false
      }
      this.emptyForm()
    },
    // 清空表单
    emptyForm() {
      this.$refs['saleReportForm'].resetFields()
      if (this.purchaseDataImport == 1)
        this.$refs['purchaseReportForm'].resetFields()
    },
    // 表单起始时间格式化
    stockStartTimeFormatter(config) {
      let stockStartTime = new Date(config.stockStartTime)
      let now = new Date()
      if (stockStartTime.getTime() >= now.getTime()) {
        this.saleReportForm.range = []
        this.purchaseReportForm.range = []
      } else {
        let start = now.getTime() - 3600 * 1000 * 24 * 30
        if (stockStartTime.getTime() < start) {
          this.saleReportForm.range = [parseTime(new Date(start), '{y}-{m}-{d}'), parseTime(now, '{y}-{m}-{d}')]
          this.purchaseReportForm.range = [parseTime(new Date(start), '{y}-{m}-{d}'), parseTime(now, '{y}-{m}-{d}')]
        } else {
          this.saleReportForm.range = [parseTime(stockStartTime, '{y}-{m}-{d}'), parseTime(now, '{y}-{m}-{d}')]
          this.purchaseReportForm.range = [parseTime(stockStartTime, '{y}-{m}-{d}'), parseTime(now, '{y}-{m}-{d}')]
        }
      }
    },
    uploadDataTemplateOpen() {
      this.$refs.uploadDataTemplate.click()
    },
    // 上传数据匹配模板
    uploadDataTemplate() {
      this.uploadDataTemplateLoading = true
      let inputDOM = this.$refs.uploadDataTemplate
      let file = inputDOM.files[0]
      let formData = new FormData()
      formData.append("file", file)
      uploadDataTemplate(this.token, this.config.id, formData).then(({data}) => {
        let {code, msg} = data
        if (code == 200)
          this.success(msg)
        else if (code == 1)
          this.error(msg)
      }).catch(() => this.error("模板上传失败，请联系管理员"))
        .finally(() => {
          this.$refs.uploadDataTemplate.value = ''
          this.uploadDataTemplateLoading = false
        })
    },
    // 下载数据匹配模板
    downloadDataTemplate() {
      this.downloadDataTemplateLoading = true
      downloadDataTemplate(this.token, this.config.id).then(res => {
        if (res.data) {
          let name = this.parentBrands.find(p => p.id == this.config.id).parentBrand
          res.headers['filename'] = "商品数据配置（" + name + "）"
          this.handleDownload(res)
        }
      }).catch(() => this.error("模板下载失败，请联系管理员")).finally(() => this.downloadDataTemplateLoading = false)
    },
    // 下载分级容差模板
    downloadPropTemplate() {
      this.downloadPropTemplateLoading = true
      downloadPropTemplate(this.config.id, this.token).then(res => {
        if (res.data) {
          this.handleDownload(res)
        }
      }).catch(() => this.error("模板下载失败，请联系管理员")).finally(() => this.downloadPropTemplateLoading = false)
    },
    // 上传分级容差模板
    openUploadPropTemplate() {
      this.$refs.uploadToleranceTemplate.click()
    },
    // 上传分级容差模板
    uploadToleranceTemplate() {
      this.uploadPropTemplateLoading = true
      let inputDOM = this.$refs.uploadToleranceTemplate
      let file = inputDOM.files[0]
      let formData = new FormData()
      formData.append("file", file)
      uploadPropTemplate(this.token, formData, this.config.id).then(({data}) => {
        let {code, msg} = data
        if (code == 200)
          this.success(msg)
        else if (code == 1)
          this.error(msg)
      }).catch(() => this.error("模板上传失败，请联系管理员"))
        .finally(() => {
          this.$refs.uploadToleranceTemplate.value = ''
          this.uploadPropTemplateLoading = false
        })
    },
    // 下载进货数据模板
    downloadStockTemplate() {
      this.downloadStockTemplateLoading = true
      downloadStockTemplate(this.config.id, this.token).then(res => {
        if (res.data) {
          this.handleDownload(res)
        }
      }).catch(() => this.error("模板下载失败，请联系管理员")).finally(() => this.downloadStockTemplateLoading = false)
    },
    // 妈咪爱下载
    downloadOfmomTemplate(type) {
      this.downloadStockTemplateLoading = true
      downloadOfmomTemplate(type, this.token).then(res => {
        console.log(res)
        if (res.data.data) {
          window.location.href = res.data.data;
          this.$notify({
            type: 'success',
            message: '导出成功',
            title: '成功',
            position: 'bottom-right'
          })
        }
      })
        .catch(() => this.error("模板下载失败，请联系管理员")).finally(() => this.downloadStockTemplateLoading = false)
    },
    uploadOfmomStockTemplate(res) {
      this.uploadStockTemplateLoading = true
      let inputDOM = this.$refs.uploadOfmomStockTemplate
      let file = inputDOM.files[0]
      let formData = new FormData()
      let type = this.ofmomUploadType
      formData.append("file", file)
      uploadOfmomStockTemplate(this.token, formData, type).then(({data}) => {
        let {code, msg} = data
        if (code == 200) {
          this.success(msg)
        } else {
          this.error(msg)
        }
      }).catch(() => this.error("模板上传失败，请联系管理员"))
        .finally(() => {
          this.$refs.uploadOfmomStockTemplate.value = ''
          this.uploadStockTemplateLoading = false
        })
    },
    openOfmomUploadStockTemplate(type) {
      this.ofmomUploadType = type
      this.uploadDialog = true;
      // this.$refs.uploadOfmomStockTemplate.click()
    },
    openUploadStockTemplate() {
      if (this.suppliers.length == 0) {
        this.error("当前账号未绑定供应商，无法上传")
      } else if (!this.stockSupplier) {
        this.error("请选择供应商")
      } else {
        this.$refs.uploadStockTemplate.click()
      }
    },
    // 上传进货数据
    uploadStockTemplate() {
      this.uploadStockTemplateLoading = true
      let inputDOM = this.$refs.uploadStockTemplate
      let file = inputDOM.files[0]
      let formData = new FormData()
      formData.append("file", file)
      uploadStockTemplate(this.token, formData, this.config.id, this.stockSupplier).then(({data}) => {
        let {code, msg} = data
        if (code == 200) {
          this.success(msg)
          this.parentBrandsChange()
        } else if (code == 1)
          this.error(msg)
      }).catch(() => this.error("模板上传失败，请联系管理员"))
        .finally(() => {
          this.$refs.uploadStockTemplate.value = ''
          this.uploadStockTemplateLoading = false
        })
    },
    // 下载进货数据
    downStock() {
      this.$refs['purchaseReportForm'].validate(valid => {
        if (valid) {
          this.downloadStockLoading = true
          let form = {
            start: this.purchaseReportForm.range[0],
            end: this.purchaseReportForm.range[1],
            parentBrand: this.config.id,
            category: this.purchaseReportForm.brands.map(p => p.id),
            product: this.purchaseReportForm.products.map(p => p.id),
            regionals: this.purchaseReportForm.regionals.map(p => p.id),
            supplier: this.purchaseReportForm.suppliers.map(p => p.id),
            provinces: this.purchaseReportForm.provinces.map(p => p.id),
            city: this.purchaseReportForm.citys.map(p => p.id),
            propValues: this.purchaseReportForm.propValues
          }
          // if (form.category.length == 0)
          //   form.category = this.categorys.map(p => p.id)
          downStock(this.token, form).then(res => {
            if (res.data) {
              this.handleDownload(res)
            }
          }).catch(() => this.error("进货数据下载失败，请联系管理员")).finally(() => this.downloadStockLoading = false)
        }
      })
    },
    // 下载进销存报告
    downloadSaleReport() {
      this.$refs['saleReportForm'].validate(valid => {
        if (valid) {
          let form = {
            start: this.saleReportForm.range[0],
            end: this.saleReportForm.range[1],
            parentBrand: this.config.id,
            category: this.saleReportForm.brands.map(p => p.id),
            product: this.saleReportForm.products.map(p => p.id),
            regionals: this.saleReportForm.regionals.map(p => p.id),
            supplier: this.saleReportForm.suppliers.map(p => p.id),
            provinces: this.saleReportForm.provinces.map(p => p.id),
            city: this.saleReportForm.citys.map(p => p.id),
            extras: this.saleReportForm.extras.map(p => p.id),
            extrasLists: this.extras,
            inventoryMonitor: this.saleReportForm.inventoryMonitor,
            propValues: this.saleReportForm.propValues
          }
          if (form.start == form.end) {
            this.error("起止时间不能相同")
          } else {
            if (form.inventoryMonitor.length == 0)
              form.inventoryMonitor = ["未预警", "预警中", "未监控"]
            // if (form.category.length == 0)
            //   form.category = this.categorys.map(p => p.id)
            this.downloadSaleReportLoading = true
            downloadSaleReport(this.token, form).then(res => {
              if (res.data) {
                this.handleDownload(res)
              }
            }).catch(() => this.error("进销存报告下载失败，请联系管理员")).finally(() => this.downloadSaleReportLoading = false)
          }
        }
      })
    },
    //在线查看进销存数据
    querySaleReport() {
      this.$refs['saleReportForm'].validate(valid => {
        if (valid) {
          this.saleReportDialog.visible = true
          this.saleReportDialog.loading = true
          this.saleReportDialog.tableData = []
          let form = {
            start: this.saleReportForm.range[0],
            end: this.saleReportForm.range[1],
            parentBrand: this.config.id,
            category: this.saleReportForm.brands.map(p => p.id),
            product: this.saleReportForm.products.map(p => p.id),
            regionals: this.saleReportForm.regionals.map(p => p.id),
            supplier: this.saleReportForm.suppliers.map(p => p.id),
            provinces: this.saleReportForm.provinces.map(p => p.id),
            city: this.saleReportForm.citys.map(p => p.id),
            extras: this.saleReportForm.extras.map(p => p.id),
            extrasLists: this.extras,
            inventoryMonitor: this.saleReportForm.inventoryMonitor,
            propValues: this.saleReportForm.propValues
          }
          if (form.start == form.end) {
            this.error("起止时间不能相同")
          } else {
            if (form.inventoryMonitor.length == 0)
              form.inventoryMonitor = ["未触发", "预警中", "未监控"]
            // if (form.category.length == 0)
            //   form.category = this.categorys.map(p => p.id)
            this.downloadSaleReportLoading = true
            querySaleReport(this.token, form).then(res => {
              if (res.data) {
                this.saleReportDialog.tableData = res.data.date
              }
            }).catch(() => this.error("进销存报告查询失败，请联系管理员")).finally(() => {
              this.downloadSaleReportLoading = false
              this.saleReportDialog.loading = false
            })
          }
        }
      })
    },
    downloadOfmomData(type) {
      this.downloadStockLoading = true;
      console.log(this.datetime)
      if (!this.datetime) {
        return this.$message.error('请选择时间');
      }

      var dataParam = {
        "type": type,
        'startTime': this.datetime[0],
        'endTime': this.datetime[1]

      }
      downloadOfmomData(this.token, dataParam).then(res => {
        if (res !== null) {
          this.handleDownload(res)
          this.$notify({
            type: 'success',
            message: '导出成功',
            title: '成功',
            position: 'bottom-right'
          })
        }
      }).catch(() => this.error("下载失败，请联系管理员"))
        .finally(() => this.downloadStockLoading = false)
    },
    success(msg) {
      this.$notify({
        type: 'success',
        message: msg,
        title: '成功',
        position: 'bottom-right'
      })
    },
    error(msg) {
      this.$notify({
        type: 'error',
        message: msg,
        title: '失败',
        position: 'bottom-right'
      })
    },
    handleDownload(res) {
      // 创建下载的链接
      // 设置该文件的mime类型，这里对应的mime类型对应为.xlsx格式
      let blob = new Blob([res.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'})
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      const fileName = decodeURI(res.headers['filename'])
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
    },
    // 处理默认选中当前日期
    getNowTime() {
      let now = new Date()
      let year = now.getFullYear() // 得到年份
      let month = now.getMonth() // 得到月份
      let date = now.getDate() // 得到日期
      month = month + 1
      month = month.toString().padStart(2, '0')
      date = date.toString().padStart(2, '0')
      let defaultDate = `${year}-${month}-${date}`
      return defaultDate
      // this.$set(this.ruleForm2, 'endDate', defaultDate)
    },
    getStartTime() {
      let now = new Date()
      now = new Date(now.getTime() + 24 * 3600 * 1000)
      now.setMonth(now.getMonth() - 1);
      let year = now.getFullYear() // 得到年份
      let month = now.getMonth() // 得到月份
      let date = now.getDate() // 得到日期
      month = month + 1
      month = month.toString().padStart(2, '0')
      date = date.toString().padStart(2, '0')
      let defaultDate = `${year}-${month}-${date}`
      return defaultDate
    },
    removeExcel(file, message) {
      var uid = file.uid;
      this.uploadSuccessExcelList = this.uploadSuccessExcelList.filter(file => file.uid !== uid);

      if (message == null || message) {
        this.$message.info(`已移除 ${file.name}`)
      }
    },
    submitUpload() {
      this.$refs.upload.submit();
    },
    uploadMethod(params) {
      this.uploadStockTemplateLoading = true
      const file = params.file
      let formData = new FormData() // 实例化一个formData，用来做文件上传
      let type = this.ofmomUploadType;
      formData.append('file', file)
      uploadOfmomStockTemplate(this.token, formData, type).then(({data}) => {
        let {code, msg} = data
        if (code === 200) {
          this.removeExcel(file, false)
          // this.uploadSuccessExcelList.push(file);
          this.success(msg)
        } else {
          this.error(msg)
        }
      }).catch(() => this.error("模板上传失败，请联系管理员"))
        .finally(() => {
          this.uploadStockTemplateLoading = false
        })
    },
    //关闭上传dialog
    handleClose() {
      this.uploadSuccessExcelList = [];
      this.uploadDialog = false;
    },
    openUploadRecordDialog() {
      this.uploadRecordDialog = true;
      this.showUploadRecord();
    },
    //查看数据上传记录
    showUploadRecord(e) {
      var page = e ? e : 1;

      if (!this.uploadRecordType)
        return;

      var param = {
        'type': this.uploadRecordType,
        'page': page
      }

      this.recordTableLoading = true;

      queryUploadRecord(this.token, param).then(({data}) => {
        let {code, msg} = data
        if (code === 200) {
          this.recordTable = data.data;
        } else {
          this.error("查询失败，请联系管理员");
        }
      }).catch(() => {
        this.error("查询失败，请联系管理员")
      }).finally(() => {
        this.recordTableLoading = false;
      })
    },
    //关闭数据上传记录弹窗
    handleCloseRecord() {
      this.clearRecord();
      this.uploadRecordDialog = false;
    },
    //清除table数据
    clearRecord() {
      this.recordTable = [];
    },
    //打开汇总维度切换弹窗
    openPropUpdateDialog() {
      this.propUpdateDialog = {
        loading: false,
        visible: true,
        file: null,
        downDisabled: false,
        isProp: this.propUpdateDialog.isProp
      }
    },
    //上传汇总维度切换文件
    uploadPropUpdateSubmit() {
      let formData = new FormData()
      formData.append("file", this.propUpdateDialog.file)
      this.propUpdateDialog.loading = true;
      uploadSupplierPropValue(this.token,formData,this.parentBrandId).then(({data}) => {
        let {code} = data
        let {msg,success,errorIndex1,errorIndex2} = data.data
        if (code === 200) {
          if (msg) {
            this.error(msg)
          } else {
            let msgHtml = `<div>成功修改：${success}条</div>`
            if (errorIndex1 && errorIndex1.length > 0) {
              msgHtml += `<div style="margin-top: 20px">${errorIndex1.length}条未找到旧汇总维度 导致修改失败：</div>`
              // errorIndex1.forEach(item => {
              //   msgHtml += `<div>第${item}行</div>`
              // })
            }
            if (errorIndex2 && errorIndex2.length > 0) {
              msgHtml += `<div style="margin-top: 20px">${errorIndex2.length}条数据填写不规范（为空或过长）导致修改失败：</div>`
              errorIndex2.forEach(item => {
                msgHtml += `<div>第${item}行</div>`
              })
            }
            msgHtml = `<div style="max-height: 400px; overflow-y: auto;">${msgHtml}</div>`;
            this.$alert(msgHtml, '上传成功', {
              confirmButtonText: '确定',
              dangerouslyUseHTMLString: true,
              callback: action => {
                this.propUpdateDialog.visible = false
              }
            })
          }
        } else {
          this.error("上传失败，请联系管理员")
        }
      }).finally(() => this.propUpdateDialog.loading = false)
    },
    //下载汇总维度切换模板
    downloadUpdatePropTemplate() {
      this.propUpdateDialog.downDisabled = true;
      downloadSupplierPropValue(this.token,this.parentBrandId).then((res) => {
        if (res.data) {
          this.handleDownload(res)
        }
      }).finally(() => this.propUpdateDialog.downDisabled = false)
    },
  }
}
</script>

<style scoped>
.el-form--label-top /deep/ .el-form-item__label {
  float: none;
  display: inline-block;
  text-align: left;
  padding: 0;
}

.el-form--label-top /deep/ .el-form-item--small.el-form-item {
  margin-bottom: 10px;
}

.divider {
  width: 100%;
  border: 1px solid #DCDFE6;
  background-color: #DCDFE6;
}

.ov-button {
  color: white;
  variant: 'outlined';
  border-color: #FF6633;
  background-color: #FF6633
}

.ov-inline {
  display: inline-block;
  vertical-align: top;
  margin-right: 10px;
}

.el-select .el-select-dropdown__list {
  list-style: none;
  padding: 0px 0;
  margin: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.dialog-title {
  margin-top: 10px;
  color: black;
  font-size: 24px;
  font-weight: 600;
}

.dialog-body {
  margin-bottom: 10px;
  line-height: 24px;
  font-size: 16px;
  text-align: center;
  color: black;
}

.dialog-body > div {
  margin-bottom: 20px;
}

.dialog-body .dialog-description {
  text-align: left;
  background-color: #f3f3f3;
  padding: 10px;
  border-radius: 10px;
  color: #979797;
  margin: 0 50px 20px;
}

.el-link.el-link--default {
  color: #008AFF;
  font-size: 16px;
}

.el-link.el-link--default:hover {
  color: #4ca2ea;
}

.el-link.el-link--default.is-underline:hover:after {
  border-color: #4ca2ea
}

.avatar-uploader-icon {
  border-radius: 10px;
  background-color: #f3f3f3;
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 80px;
  line-height: 80px;
  text-align: center;
}

.avatar {
  width: 178100;
  height: 17880;
  display: block;
}

.dialog-footer {
  margin-bottom: 100px;
}
.description {
  color: #979797;
  background-color: #F3F3F3;
  padding: 10px;
  border-radius: 10px;
  text-align: left;
  line-height: 23px;
}

.details >>> .el-dialog {
  margin-top: 7vh !important;
}

.details >>> .el-dialog__body {
  padding-top: 0;
  padding-bottom: 0;
}

.details >>> .el-dialog__footer {
  padding-top: 0;
}
</style>
